import { Link, useNavigate } from "react-router-dom";
import { Image } from "semantic-ui-react";
import BEAGLEGPTLOGO from '../static/beagle-gpt-logo.png';

/**
 * ErrorPage Module
 * @module ErrorPage
 */
/**
 * ErrorPage component renders a user-friendly error message when a requested page is unavailable.
 * It provides a link to navigate back to the login page and displays the BeagleGPT logo.
 *
 * @returns {JSX.Element} The rendered error page component.
 * 
 * @example
 * <ErrorPage />
 */

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'}}>
      <h1>Oops!!</h1>
      <h2>The page you are requesting is not available!!</h2>
      <h2>Go back to <Link path='../Login/Login' onClick={()=>navigate('/login')}>login</Link> page</h2>
      <Image src={BEAGLEGPTLOGO} alt="beagle_gpt_logo"/>
    </div>
  );
};

export default ErrorPage;
